import { generateNumberMask } from 'components/modules/Insurance/Insurance.helpers';
import { VALUE_FIELDS } from 'store/carInstance/constants';

export const NAME = VALUE_FIELDS.PRICE;

export const PRICE_MASK = generateNumberMask({ max: 10 ** 12, postfix: '₽' });
